import React from 'react';
import Api from '../../api';
import { onError } from '../../libs/error-lib';
import { useRefreshScore } from '../../libs/hooks-lib';
import TopScoreBoardContainer from 'boss-ui/src/containers/TopScoreBoard';

const API = new Api();


export default function TopScoreBoard({ eventId }) {
  return <TopScoreBoardContainer eventId={eventId} api={API} useRefreshScore={useRefreshScore} onError={onError} isAdmin={true} />;
}
